import { timers } from "jquery"

/**
 * Convertit une date en format mm-dd-yyyy en format dd-mounth-yyyy (ex:02-18-2025 => 17 février 2025)
 * @param {string} date - Date à convertir en format mm-dd-yyyy 
 * @param {object} local - Dictionnaire de la langue souhaité. 
 * @param {boolean} uppercase - Retourner la chaine de caractère en majuscule ou non 
 * @param {boolean} minify - Retourner la date en format dd/mm/yyyy
 * @returns {string} Date reconvertit
 */
export default function parseDate(date,local,uppercase=false,minify=false){
    const DateTarget = new Date(date)
    let day,month,year

    day = DateTarget.getDate()
    year = DateTarget.getFullYear()

    switch(DateTarget.getMonth()){
        case 0:
        month=local.calendar.month.january
        break;

        case 1:
        month=local.calendar.month.february
        break;

        case 2:
        month=local.calendar.month.march
        break;

        case 3:
        month=local.calendar.month.april
        break;

        case 4:
        month=local.calendar.month.may
        break;

        case 5:
        month=local.calendar.month.june
        break;

        case 6:
        month=local.calendar.month.july
        break;

        case 7:
        month=local.calendar.month.august
        break;

        case 8:
        month=local.calendar.month.september
        break;

        case 9:
        month=local.calendar.month.october
        break;

        case 10:
        month=local.calendar.month.november
        break;

        case 11:
        month=local.calendar.month.december
        break;
    }

    if (minify) return `${day}/${DateTarget.getMonth()+1}/${year}`
    else return uppercase ?`${day} ${month} ${year}`.toUpperCase(): `${day} ${month} ${year}`
}

/**
 * Converit un objet de la clé "staticPage" d'un dictionnaire séléctionné pour les métadonnées
 * @param {object} local - Dictionnaire séléctionné 
 * @returns {{title:string,keywords:string,description:string}} - Métadonnées
 */
export function  parseStaticMetadata(local) {
    return {
        ...local,
        title:local.title+" | rma.ac.be",
        keywords:local.tags.split(",")
      }
}

/**
 * Retourne les métadonnées d'une page à partir de ses données.
 * @param {object} data - Donnée de la page 
 * @param {"fr"|"en"|"nl"} lang - Langue dans laquelle retourner les métadonnée
 * @returns {{title:string,keywords:string,description:string}} - Métadonnées
 */
export function parsePageMeta(data,lang){
    switch(lang){
        case 'fr':

        return {
            title:data.textData[0].name + " | rma.ac.be",
            description:data.textData[0].subName,
            keywords:data.textData[0].metadonnée.split(",")
        }

        case 'en':
        return {
            title:data.textData[1].name + " | rma.ac.be",
            description:data.textData[1].subName,
            keywords:data.textData[1].metadonnée.split(",")
        }

        case 'nl':
        return {
            title:data.textData[2].name, 
            description:data.textData[2].subName,
            keywords:data.textData[2].metadonnée.split(",")
        }
    }
}

/**
 * Retourne les métadonnées d'une article à partir de ses données.
 * @param {object} article - Donnée de la page 
 * @param {"fr"|"en"|"nl"} lang - Langue dans laquelle retourner les métadonnée
 * @returns {{title:string,keywords:string,description:string}} - Métadonnées
 */
export function parseArticleMeta (article,lang){
    const data = article
    switch(lang){
        case 'fr':
        return{
            title:decodeURI(atob(data.nameFr))+ " | rma.ac.be",
            description:data.sums?.fr,
            keywords:data.metadata?.fr?.split(",")
        }

        case 'en':
        return{
            title:decodeURI(atob(data.nameEn))+ " | rma.ac.be",
            description:data.sums?.en,
            keywords:data.metadata?.en?.split(",")
        }

        case 'nl':
        return{
            title:decodeURI(atob(data.nameNl))+ " | rma.ac.be",
            description:data.sums?.nl,
            keywords:data.metadata?.nl?.split(",")
        }
    }
}

/**
 * Retourne les métadonnées d'un évènement à partir de ses données.
 * @param {object} event - Donnée de l'évènement 
 * @param {"fr"|"en"|"nl"} lang - Langue dans laquelle retourner les métadonnée
 * @returns {{title:string,keywords:string,description:string}} - Métadonnées
 */
export function parseEventMeta(event,lang){
    return{
        title:event.titre[lang]+" | rma.ac.be",
        description:event.metadata && event.metadata[lang]? event.metadata[lang].sums : "",
        keywords:event.metadata && event.metadata[lang]? event.metadata[lang].tags : [event.titre[lang]]
    }
}

/**
 * Convertir une heure en format 00:00 vers un autre format en focntion dans la langue séléctionnée :
 * - 00h00 pour la langue française
 * - 00u00 pour le néerlandais
 * - 00:00 pour l'anglais
 * 
 * @param {string} hour heure à convertir dans le format 00:00 
 * @param {"fr"|"en"|"nl"} lang - Langue dans laquel convertir l'heure 
 * @returns {"string"} Heure reconvertit
 */
export function parseHour(hour,lang){
    let parsedHour
    switch (lang){
        case 'fr':
        parsedHour = hour.replace(":","h")
        break;

        case 'en':
        parsedHour = hour
        break;

        case 'nl':
        parsedHour = hour.replace(":",".") + " u"
    }

    return parsedHour
}

/**
 * Convertit un jour de découverte en un évènement
 * @param {*} discoveryDay 
 * @param {*} localFR 
 * @param {*} localNL 
 * @param {*} localEN 
 * @param {*} lang 
 * @param {*} discoveryDayPageData 
 * @returns 
 */
export function parseDiscoveryDayToEvent(discoveryDay,localFR,localNL,localEN,discoveryDayPageData){

    console.log(discoveryDay)
    let titleFR,titleNL,titleEN


    switch(discoveryDay.type){
        case 'classic':
            titleFR = localFR.discoveryDays.classic
            titleNL = localNL.discoveryDays.classic
            titleEN = localEN.discoveryDays.classic
            
            break;

        case 'special-division':
            titleFR = localFR.discoveryDays.sdiv
            titleNL = localNL.discoveryDays.sdiv
            titleEN = localEN.discoveryDays.sdiv
            break;


        case 'winter-camp-elsenborn':
            titleFR = localFR.discoveryDays.elsenborn
            titleNL = localNL.discoveryDays.elsenborn
            titleEN = localEN.discoveryDays.elsenborn
            break;
    }
    
    return {
      titre:{
        fr:titleFR,
        nl:titleNL,
        en:titleEN
      },
      texte_fr: '',
      texte_nl: '',
      texte_en: '',
      highlight:"",
      adresse:{
        fr:{
            lieu:discoveryDayPageData?.general.place.fr || "",
        },
        nl:{
            lieu:discoveryDayPageData?.general.place.nl || "",
        },
        en:{
            lieu:discoveryDayPageData?.general.place.en || "",
        }
      },
      date_debut: discoveryDay.date,
      date_fin: "",
      profil: "université",
      cibles: "tous",
      reservation: "obligatoire",

      isFull: discoveryDay.isFull,
      image:discoveryDayPageData?.headerImage.desktop || null,
      imageMobile:discoveryDayPageData?.headerImage.mobile || null,
      metadata:{
        fr:{
          tags:'',
          sums:''
        },
        en:{
          tags:'',
          sums:''
        },
        nl:{
          tags:'',
          sums:''
        },
      },
      show:"",
      showAgenda:"",
      eventLink:{
        fr:"",
        nl:""
      },

      access:{
        parking:"",
        transportPublic:""
      },

      documents:[],
      type:"discovery-day",
      extraData:{}
    }
    
}